var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"orgList"}},[_c('Tree',{attrs:{"data":_vm.organizationList,"id":"orgTree"},on:{"on-select-change":_vm.selectNode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }